<template>
    <div style="background-color: #fafafa;">
		<div id="newBtn" v-if="show"><span style="font-size: 50px;" class="icon iconfont icon-jiahao-o" @click="add()"></span></div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
                <div v-for="item in list" class="card" :key="item.uuid">
                    <table class="layout">
                        <tr>
                            <td class="avatar-box">
                                合同名称：
                            </td>
                            <td>
                                {{item.name}}
                            </td>
                        </tr>
                        <tr>
                            <td class="avatar-box">
                                合同状态：
                            </td>
                            <td>
                                {{item.state}}
                            </td>
                        </tr>
						<tr>
						    <td class="avatar-box">
						        签署时间：
						    </td>
						    <td>
						        {{item.creationTime}}
						    </td>
						</tr>
                        <tr>
                            <td>
                                <span style="margin-left:0;" class="icon iconfont icon-chakan"
                                      @click="checkContract(item.flowId)"></span>
                                <span style="margin-left:0;" v-if="item.state == '签署成功'" class="icon iconfont icon-file"
                                      @click="downloadContract(item.flowId)"></span>
                            </td>
                        </tr>
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
	</div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,NavBar,Toast} from 'vant';
    import eleContractService from "../service/eleContractService";
    import moment from "moment";

    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				customerId: '',
				show: true
                
            }
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[NavBar.name]: NavBar,
        },
        computed: {
            icon() {
                return "iconfont ";
            }
        },
        created: async function () {
            this.customerId = this.$route.query.customerId;
        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await eleContractService.getList(this.pageIndex, this.customerId);
                resp.data.Data.data.forEach(item => {
					if(item.state == 0) {
						item.state = "签署中"
					}else if(item.state == 1){
                        item.state = "签署成功";
                    }
              
                });
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
				this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			async add() {
				this.show = false;
				let res = await eleContractService.signContract(this.customerId);
				if (res.data.Status == 1) {
					this.show = true;
					this.onRefresh();
					Toast.success(res.data.Data);
				} else if (res.data.Status == 0) {
					this.show = true;
					Toast.fail(res.data.Data);
				}
			},
			async checkContract(flowId) {
				let res = await eleContractService.checkContract(flowId);
				if (res.data.Status == 1) {
					this.onRefresh();
					Toast.success(res.data.Data);
				} else if (res.data.Status == 0) {
					Toast.fail(res.data.Data);
				}
			},
			async downloadContract(flowId) {
				let res = await eleContractService.downloadContract(flowId);
				if (res.data.Status == 1) {
					window.location.href = '/downLoadFile?path=' + res.data.Data;
				} else if (res.data.Status == 0) {
					Toast.fail(res.data.Data);
				}
			}
        }
    };

</script>
<style>
    #newBtn{
        position:fixed;
        right:20px;
        bottom:30px;
        z-index: 9999;
    }
	td {
		padding:8px 0;
	}
</style>